import {useState} from "react";
import {
    Modal,
    Typography,
    Form,
    Input,
    Button,
    Space,
} from "antd";
import {ActivityMatchInfo, MatchParticipant} from "../../interface";
import { deleteMatchActivityParticipant } from "../../apiBridge";
import {MessageInstance} from "antd/es/message/interface";


const { Title, Text } = Typography;

interface Props {
    isOpen: boolean;
    activity: ActivityMatchInfo;
    participant: MatchParticipant | null;
    controller: React.Dispatch<React.SetStateAction<boolean>>;
    reloadController: React.Dispatch<React.SetStateAction<boolean>>;
    messageController: MessageInstance;
}

const DeleteParticipantModal: React.FC<Props> =({
    isOpen,
    activity,
    participant,
    controller,
    reloadController,
    messageController
}) => {
    const [form] = Form.useForm();

    const [loadingState, setLoadingState] = useState(false);

    const onFinishDeleteUser = async (values: any) => {
        if (!participant) {
            return false;
        }

        setLoadingState(true);

        const res = await deleteMatchActivityParticipant(activity.id, participant.id)
        if (res) {
            const data = await res.json();

            if (data.error) {
                messageController.error(data.error);
            } else {
                messageController.success("Participant removed")

                controller(false);
                reloadController(true);
            }
        }

        setLoadingState(false)
    }

    return <>
        <Modal
            footer={null}
            maskClosable={false}
            closeIcon={false}
            centered
            open={isOpen && participant !== undefined}
            width={380}
            afterOpenChange={(open) => {
                if (!open) {
                    form.resetFields();
                }
            }}
        >
            <div style={{ marginBottom: 20 }}>
                <Title level={4}>Remove User</Title>
                <Text type="secondary">
                    Removing this participant clears the schedule, bracket draft, and published matches for their categories. Setup is reset if the draw size changes.
                </Text>
            </div>
            <Form
                name="createuserform"
                layout="vertical"
                onFinish={onFinishDeleteUser}
                autoComplete="off"
                form={form}
                validateTrigger="onSubmit"
            >
                <Form.Item
                    label="Type 'remove' to confirm remove"
                    name="confirmation"
                    rules={[
                        { message: "Please type 'remove' to remove user." },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (value !== "remove") {
                                    return Promise.reject(
                                        new Error("Please type the word 'remove'")
                                    );
                                } else {
                                    return Promise.resolve();
                                }
                            },
                        }),
                    ]}
                >
                    <Input />
                </Form.Item>
                <div style={{ textAlign: "right" }}>
                    <Space>
                        <Button onClick={() => controller(false)}>Cancel</Button>

                        <Form.Item style={{ margin: 0 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loadingState}
                                danger
                            >
                                Remove
                            </Button>
                        </Form.Item>
                    </Space>
                </div>
            </Form>
        </Modal>
    </>
}

export default DeleteParticipantModal